export default {
  name: 'calendar',
  type: 'action',
  isRequired: true,
  essential: false
}
